import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=6960b9ba&scoped=true&"
import script from "./Manage.vue?vue&type=script&lang=ts&"
export * from "./Manage.vue?vue&type=script&lang=ts&"
import style0 from "./Manage.vue?vue&type=style&index=0&id=6960b9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960b9ba",
  null
  
)

export default component.exports